<template>
  <div class="brand-page">
    <div class="container">
      <h1>{{ $t('brand.title') }}</h1>
      <div class="brand-gallery">
        <div 
          v-for="(brand, index) in brands" 
          :key="index"
          class="brand-card"
        >
          <img :src="brand.image" :alt="brand.name" class="brand-image">
          <!-- <h3>{{ brand.name }}</h3>
          <p>{{ brand.description }}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandPage',
  data() {
    return {
      brands: [
        {
          name: '品牌 1',
          description: '品牌描述內容',
          image: '/inritek-web/images/bugeto.png'
        },
        {
          name: '品牌 2',
          description: '品牌描述內容',
          image: '/inritek-web/images/joudy.png'
        },
        {
          name: '品牌 3',
          description: '品牌描述內容',
          image: '/inritek-web/images/wonyarn.png'
        },
        // {
        //   name: '品牌 4',
        //   description: '品牌描述內容',
        //   image: '/inritek-web/images/goddes.png'
        // }
      ]
    }
  }
}
</script>

<style scoped>
.brand-page {
    padding: 0;
    background-color: #ffffff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding : 40px 20px;
}

h1 {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 40px;
  color: #333;
}

.brand-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.brand-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.brand-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.brand-image {
  width: 100%;
  height: 200px;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 15px;
  background-color: #f9f9f9;
}

.brand-card h3 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  color: #333;
}

.brand-card p {
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
}

/* 手機版 */
@media (max-width: 768px) {
  .brand-page {
    padding: 0;
  }

  h1 {
    font-size: 1.5rem;
    margin-bottom: 30px;
  }

  .brand-gallery {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .brand-image {
    height: 150px;
  }
}
</style>